import React from 'react';
import Modal from '../../helpers/Modal';
import ModalButtons from './ModalButtons';

const ConfirmationModal = ({ onClose, onConfirm, confirmLabel, confirmText, open, title, className }) => (
    <Modal className={className || ''} open={open} onClose={onClose}>
        <h4 className="ckp-admin-modal-forms-title ckp-ts-h1">{title || 'Confirmation'}</h4>
        <div className="ckp-admin-modal-forms-text">{confirmText}</div>
        <ModalButtons cancelAction={onClose} confirmAction={onConfirm} confirmLabel={confirmLabel} />
    </Modal>
);

export default ConfirmationModal;
